import { render, staticRenderFns } from "./Loading2.vue?vue&type=template&id=767cfa18"
import script from "./Loading2.vue?vue&type=script&lang=js"
export * from "./Loading2.vue?vue&type=script&lang=js"
import style0 from "./Loading2.vue?vue&type=style&index=0&id=767cfa18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports